import { isCurrencyCodeString } from 'pricing-pages-ui-components/currency/types';
export function buildHsocPriceDisplay(pricing, selectedTerm, currencyCode, tierName) {
  if (!isCurrencyCodeString(currencyCode)) {
    return undefined;
  }

  /* The FREE tier has no purchase options; mirror the public pages and show an
   * explicit $0 rather than no price. */
  if (tierName === 'FREE') {
    return {
      price: 0,
      currencyCode
    };
  }
  if (!pricing) {
    return undefined;
  }
  const resolvedCurrencyCode = currencyCode;

  /* Prefer the selected term, but fall back to the annual price when this tier
   * doesn't offer it. ENTERPRISE is annual-only
   * (we never get a monthly value back), so it keeps showing its annual price
   * even while the monthly toggle is active.
   * Mirrors v1's usePerMonthPriceForTerm resolvedTerm fallback. */
  const termsToTry = selectedTerm === 'ANNUAL' ? ['ANNUAL'] : [selectedTerm, 'ANNUAL'];
  for (const term of termsToTry) {
    const option = pricing.purchaseOptions[term];
    if (!option) {
      continue;
    }
    const price = Number(option.monthlyPrice);
    if (option.monthlyPrice.trim() === '' || !Number.isFinite(price)) {
      continue;
    }
    return {
      price,
      currencyCode: resolvedCurrencyCode
    };
  }
  return undefined;
}
export function hasMultipleBillingTerms(productsByTier) {
  if (!productsByTier) {
    return false;
  }
  return Object.values(productsByTier).some(tier => Object.keys(tier.pricing.purchaseOptions).length > 1);
}